// extracted by mini-css-extract-plugin
module.exports = {"label":"contractingSimplified_label__2jUCC"};